import { combineReducers } from "@reduxjs/toolkit";
import uploadReducer from "reducers/uploadSlice";
import authReducer from "reducers/authSlice";
import loadingReducer from "reducers/loadingSlice";
import registerReducer from "reducers/registerSlice";
import productReducer from "reducers/productSlice";
import informationReducer from "reducers/informationSlice";
import transactionReducer from "reducers/transactionSlice";
import chatReducer from "reducers/chatSlice";
import companyReducer from "reducers/companySlice";
import conversationInquiryReducer from "reducers/ConversationInquirySlice";
import { baseApi } from "reducers/baseApi";

const rootReducer = combineReducers({
  register: registerReducer,
  information: informationReducer,
  upload: uploadReducer,
  auth: authReducer,
  chat: chatReducer,
  loading: loadingReducer,
  product: productReducer,
  transaction: transactionReducer,
  company: companyReducer,
  conversationInquiry: conversationInquiryReducer,
  [baseApi.reducerPath]: baseApi.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
